export default {"src":"/_next/static/media/money.5e774781.svg","height":24,"width":24};